import { PropsWithChildren } from 'react';

import { Alert } from './Alert';

interface IAlertWarningProps extends PropsWithChildren {
  readonly title: string;
  readonly description?: string;
}

export function AlertWarning({
  title,
  description,
  children,
}: IAlertWarningProps) {
  return (
    <Alert
      icon={
        <img
          src="/images/icon-warning.png"
          alt="warning"
          className="w-[6.25rem]"
        />
      }
      title={title}
      description={description}
    >
      {children}
    </Alert>
  );
}
